import React from 'react';
import '../../containers/Blogs/Blogs.css';

const Blogs = () => {
  return (
         <div className="tpi-coming-soon font-poppins">
            <h1>Coming Soon</h1>
        </div>
  );
};

export default Blogs;
